import i18next from "i18next";
import { FULL_EMAIL_REGEX } from "Services/constants";
import { isEmpty } from "Shared/helpers/stringHelper";
import { Rule } from "./ValidationTypes";

export const createRequiredRule = (
	message?: string,
	scope: "form" | "field" = "form",
	validateImmediately?: boolean
): Rule => ({
	message: {
		scope,
		text: message ?? i18next.t("Debes completar todos los campos"),
		validateImmediately,
	},
	type: "required",
	validate: async (value) => !isEmpty(value?.toString().trim()),
});

export const createEmailRule = (message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("El correo electrónico no es válido."),
		validateImmediately,
	},
	type: "email",
	validate: async (value) => FULL_EMAIL_REGEX.test(value.toString()),
});

export const createMatchRule = (regex: RegExp, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("The value must match the required pattern"),
		validateImmediately,
	},
	type: "regex",
	validate: async (value) => value.toString().match(regex) !== null,
});

export const createNotMatchRule = (regex: RegExp, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("The value must not match the required pattern"),
		validateImmediately,
	},
	type: "regex",
	validate: async (value) => value.toString().match(regex) === null,
});
